import Layout from '../../components/feature/Layout';
import ServicesOverviewSection from './components/ServicesOverviewSection';

export default function ServicesPage() {
  return (
    <Layout>
      <ServicesOverviewSection />
    </Layout>
  );
}
